import { connect } from 'react-redux'
import { redirect } from 'redux-first-router'
import {
  doOpenReplyDirectPage,
  doOpenTicketPage,
  doOpenForwardPageExpanded,
} from 'actions/pages'
import {
  selectIsReplyHeaderExpanded,
  selectIsReplyingAll,
  selectIsReplyingDirect,
  selectIsForwarding,
} from 'selectors/page'
import SwitcherButton from './view'

const select = state => ({
  isExpanded: selectIsReplyHeaderExpanded(state),
  isReplyingAll: selectIsReplyingAll(state),
  isReplyingDirect: selectIsReplyingDirect(state),
  isForwarding: selectIsForwarding(state),
})

const performFactory = (initialState, initialOwnProps) => {
  const { ticketId } = initialOwnProps

  return dispatch => ({
    doOpenReplyDirectPage: expand =>
      dispatch(
        redirect(doOpenReplyDirectPage(ticketId, { expand, show: ['subject'] }))
      ),
    doOpenTicketPage: expand =>
      dispatch(
        redirect(doOpenTicketPage(ticketId, { expand, show: ['subject'] }))
      ),
    doOpenForwardPageExpanded: () =>
      dispatch(
        redirect(doOpenForwardPageExpanded(ticketId, { show: ['subject'] }))
      ),
  })
}

export default connect(select, performFactory)(SwitcherButton)
